






















































import {
    Component, Watch, Prop, Mixins,
} from 'vue-property-decorator';
import moment from 'moment';
import ProductListHeader from '@/components/product/product-list/ProductListHeader.vue';
import ProductListContent from '@/components/product/product-list/ProductListContent.vue';
import { map, findIndex } from 'lodash';
import { MUTATE_PRODUCTS, DELETE_PRODUCT } from '@/store/modules/product';
import { ProductInfo, CertificateInfo } from '@luxtag/papybase';
import { certificate } from '@/plugins/papybase/papybaseInit';
import SimpleDialog from '@/components/global/SimpleDialog.vue';
import SearchedProductMixin from '@/mixins/vue/SearchedProductMixin';
import GAErrorEvent from '@/mixins/vue/gAnalytics/GAErrorEvent';

@Component({
    components: {
        ProductListHeader,
        ProductListContent,
        SimpleDialog,
    },
})
export default class ProductList extends Mixins(SearchedProductMixin, GAErrorEvent) {
    @Prop(Array) public products!: any[];

    @Prop(({ default: [] })) public selectedProductIds!: number[];

    public theSelectedProductIds: number[] = this.selectedProductIds;

    public showDeleteProductConfirmation = false;

    public panel: boolean[] = [];

    public activeDeleteProductId = -1;

    public productListEvent(action: string, label: any) {
        this.$ga.event('Product list', 'click', action, label);
    }

    onInputExpand(product: any, event: any) {
        if (this.$route.params.id) {
            product.item.expand = event;
        } else {
            product.expand = event;
        }
    }

    onClickDelete(productId: number) {
        this.productListEvent(`Delete product ${productId}`, 'Delete');
        this.activeDeleteProductId = productId;
        this.showDeleteProductConfirmation = true;
    }

    public onConfirmDelete(isConfirm:boolean) {
        if (isConfirm) {
            const confirmedId = this.activeDeleteProductId;
            certificate.deleteCertificateByID(this.jwt, this.activeDeleteProductId).then((res) => {
                if (res) {
                    this.$store.commit(DELETE_PRODUCT, confirmedId);
                }
            }).catch((err) => {
                this.errorEvent('deleteCertificateByID', err);
                console.error(err);
            });
        }
    }

    get activeDeleteProductName() {
        const product: CertificateInfo = this.$store.getters.getProduct(this.activeDeleteProductId);
        if (product) {
            const productUI = this.translateProductToProductUI(product);
            return productUI.name;
        }
        return '';
    }

    get jwt() {
        return this.$store.getters.getJwt;
    }

    @Watch('selectedProductIds')
    private onSelectedProductsChanged(val: any) {
        this.theSelectedProductIds = val;
    }

    private mounted() {
        // this.unExpandAll();
        // this.onProductIdChanged(this.$route.params.id, '');
    }
}
